// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation-menu {
  border-right: 1px solid var(--color-base-border);
  border-bottom: 1px solid var(--color-base-border);
  position: relative;
}
.navigation-menu .navigation.button:first-of-type {
  border-top-width: 2px;
}
.navigation-menu .search-tile {
  border-top-width: 2px;
}
.navigation-menu .product {
  height: 2rem;
  line-height: 2rem;
}
.navigation-menu .icon.new-window {
  margin: 0;
  padding: 0 0.5rem;
  top: -0.05rem;
  fill: var(--color-base-draw);
  stroke: var(--color-base-draw);
}

.navigation-menu-toggle {
  background: none;
  border: none;
  display: block;
  font-size: 1rem;
  height: auto;
  padding: 0.5rem 1rem;
  position: absolute;
  top: 0;
  left: 0;
  text-align: left;
  width: auto;
  z-index: 99;
}
.navigation-menu-toggle .icon {
  fill: var(--color-elevated-draw);
}

.navigation-menu {
  background-color: var(--color-base-canvas);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  white-space: nowrap;
}
.navigation-menu .navigation-group {
  flex-shrink: 1;
}
.navigation-menu .navigation-logo {
  display: table;
  flex-grow: 1;
}
.navigation-menu .navigation-link-qci {
  display: table-cell;
}
.navigation-menu .logo.qci {
  position: unset;
  width: 6rem;
  margin: 2rem 0 1.5rem 0;
}
.navigation-menu .search-tile {
  border-top: 3px solid var(--color-base-border);
}
.navigation-menu .search-tile .icon {
  fill: var(--color-elevated-draw);
}
.navigation-menu .search-tile .search-input {
  margin: 1rem auto;
  padding-right: 2rem;
  width: 8.3rem;
}
.navigation-menu .search-tile .search-label-text {
  display: none;
}
.navigation-menu .search-tile .search-clear-button {
  background: none;
  border: none;
  margin-top: 0.9rem;
  position: absolute;
  right: 0.35rem;
  opacity: 0.7;
}
.navigation-menu .search-tile .search-clear-button:disabled {
  display: none;
}
.navigation-menu .search-tile .search-clear-button .icon.clear {
  margin: 0;
  top: 0;
  right: 0.25rem;
  height: 1.75rem;
}
.navigation-menu .search-tile .search-label:has(.search-input:focus) .search-help-button {
  opacity: 1;
}
.navigation-menu .search-tile .search-help-button {
  background: none;
  border: none;
  margin-top: 0.9rem;
  position: absolute;
  right: 0.35rem;
  opacity: 0.3;
}
.navigation-menu .search-tile .search-help-button:disabled {
  display: none;
}
.navigation-menu .search-tile .search-help-button .icon.info {
  margin: 0;
  top: 0;
  right: 0.25rem;
  height: 1.75rem;
}
.navigation-menu .search-tile .search-help-copy {
  background-color: var(--color-elevated-canvas);
  border: var(--border-width) solid var(--color-elevated-border);
  color: var(--color-elevated-text);
  display: none;
  line-height: 1.5rem;
  margin-top: -6.2rem;
  padding: 1rem;
  position: absolute;
  left: 13.5rem;
  text-align: left;
  white-space: pre-wrap;
  width: 20rem;
}
.navigation-menu .search-tile.help .search-label {
  z-index: 1000;
}
.navigation-menu .search-tile.help .search-help-backdrop {
  background-color: rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 13rem;
  animation-name: blur-in;
  animation-duration: 0.1s;
  animation-fill-mode: forwards;
  z-index: 999;
}
.navigation-menu .search-tile.help .search-help-copy {
  display: block;
  z-index: 1000;
}
.navigation-menu .search-tile.help .search-help-copy > p {
  margin: 0;
}
.navigation-menu .search-tile.help .search-examples {
  list-style-type: disc;
  margin-left: 1.5rem;
}
.navigation-menu .search-tile.help .search-example-label {
  color: var(--color-base-text);
  display: block;
  margin-top: 1.3rem;
  margin-bottom: 0.3rem;
}
.navigation-menu .search-tile.help .search-example-example {
  font-family: ui-monospace;
  font-size: 1.2rem;
}
.navigation-menu .button.navigation {
  background: none;
  border: none;
  display: block;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  text-align: left;
  width: 100%;
  height: auto;
}
.navigation-menu .button.navigation.current {
  background-color: var(--color-base-border);
}
.navigation-menu .button.navigation.sign-out {
  border-bottom: none;
  border-top: 1px solid var(--color-base-border);
  color: var(--color-base-text);
  display: block;
  height: 3.2rem;
  margin-bottom: 0 !important;
  margin-top: 2rem;
  text-align: center;
}
.navigation-menu .button.navigation.sign-out.confirm {
  color: var(--color-elevated-warn);
}
.navigation-menu .button.navigation {
  border-bottom: 1px solid var(--color-base-border);
  font-size: 0.85rem;
  padding: 0.2rem 1rem;
}
.navigation-menu .button.navigation:first-of-type:not(.documentation) {
  border-top: 2px solid var(--color-base-border);
  font-size: 1rem;
  padding: 0.35rem 1rem;
}
.navigation-menu .button.navigation:last-child {
  margin-bottom: 2rem;
}

.chrome .navigation-menu {
  min-height: max(100vh - 1px, 38rem);
}`, "",{"version":3,"sources":["webpack://./src/style/navigation_menu.scss"],"names":[],"mappings":"AAAA;EACE,gDAAA;EACA,iDAAA;EACA,kBAAA;AACF;AACE;EACE,qBAAA;AACJ;AACE;EACE,qBAAA;AACJ;AAEE;EACE,YAAA;EACA,iBAAA;AAAJ;AAEE;EACE,SAAA;EACA,iBAAA;EACA,aAAA;EACA,4BAAA;EACA,8BAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EAAoB,MAAA;EAAQ,OAAA;EAC5B,gBAAA;EACA,WAAA;EACA,WAAA;AACF;AACE;EACE,gCAAA;AACJ;;AAyCA;EACE,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EAKA,mBAAA;AA1CF;AA6CE;EACE,cAAA;AA3CJ;AA6CE;EACE,cAAA;EACA,YAAA;AA3CJ;AA6CE;EACE,mBAAA;AA3CJ;AA+CE;EAEE,eAAA;EACA,WAAA;EACA,uBAAA;AA9CJ;AAiDE;EACE,8CAAA;AA/CJ;AAiDI;EACE,gCAAA;AA/CN;AAkDI;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;AAhDN;AAkDI;EACE,aAAA;AAhDN;AAkDI;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EAAoB,cAAA;EACpB,YAAA;AA/CN;AAgDM;EACE,aAAA;AA9CR;AAgDM;EACE,SAAA;EACA,MAAA;EACA,cAAA;EACA,eAAA;AA9CR;AAiDI;EACE,UAAA;AA/CN;AAiDI;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EAAoB,cAAA;EACpB,YAAA;AA9CN;AA+CM;EACE,aAAA;AA7CR;AA+CM;EACE,SAAA;EACA,MAAA;EACA,cAAA;EACA,eAAA;AA7CR;AAgDI;EACE,8CAAA;EACA,8DAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EAAoB,aAAA;EACpB,gBAAA;EACA,qBAAA;EACA,YAAA;AA7CN;AAgDM;EACE,aAAA;AA9CR;AAgDM;EACE,oCAAA;EACA,eAAA;EAAiB,MAAA;EAAQ,QAAA;EAAU,SAAA;EAAW,WAAA;EAC9C,uBAAA;EACA,wBAAA;EACA,6BAAA;EACA,YAAA;AA1CR;AA4CM;EACE,cAAA;EACA,aAAA;AA1CR;AA2CQ;EACE,SAAA;AAzCV;AA4CM;EACE,qBAAA;EACA,mBAAA;AA1CR;AA6CM;EACE,6BAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AA3CR;AA6CM;EACE,yBAAA;EACA,iBAAA;AA3CR;AAgDE;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AA9CJ;AAgDI;EACE,0CAAA;AA9CN;AAiDI;EACE,mBAAA;EACA,8CAAA;EACA,6BAAA;EACA,cAAA;EACA,cAAA;EACA,2BAAA;EAGA,gBAAA;EACA,kBAAA;AAjDN;AAoDM;EACE,iCAAA;AAlDR;AAuDE;EACE,iDAAA;EACA,kBAAA;EACA,oBAAA;AArDJ;AAuDI;EACE,8CAAA;EACA,eAAA;EACA,qBAAA;AArDN;AAuDI;EACE,mBAAA;AArDN;;AA0DA;EACE,mCAAA;AAvDF","sourcesContent":[".navigation-menu {\n  border-right: 1px solid var(--color-base-border);\n  border-bottom: 1px solid var(--color-base-border);\n  position: relative;\n\n  .navigation.button:first-of-type {\n    border-top-width: 2px;\n  }\n  .search-tile {\n    border-top-width: 2px;\n  }\n\n  .product {\n    height: 2rem;\n    line-height: 2rem;\n  }\n  .icon.new-window {\n    margin: 0;\n    padding: 0 0.5rem;\n    top: -0.05rem;\n    fill: var(--color-base-draw);\n    stroke: var(--color-base-draw);\n  }\n}\n\n.navigation-menu-toggle {\n  background: none;\n  border: none;\n  display: block;\n  font-size: 1rem;\n  height: auto;\n  padding: 0.5rem 1rem;\n  position: absolute; top: 0; left: 0;\n  text-align: left;\n  width: auto;\n  z-index: 99;\n\n  .icon {\n    fill: var(--color-elevated-draw);\n  }\n}\n\n\n// @keyframes slidein {\n//   from {left: -13rem;}\n//   to {left: 0;}\n// }\n\n// @keyframes slideout {\n//   from {left: 0;}\n//   to {left: -13rem;}\n// }\n// .root-navigation.navigation-menu-opening {\n//   .navigation-menu {\n//     animation-name: slidein;\n//     animation-duration: 0.25s;\n\n//     .product {\n//       animation-name: product-fade-in;\n//       animation-duration: 0.25s;\n//       animation-iteration-count: 1;\n//       animation-timing-function: ease-in;\n//     }\n//   }\n// }\n\n// .root-navigation.navigation-menu-closing {\n//   .navigation-menu {\n//     animation-name: slideout;\n//     animation-duration: 0.25s;\n\n//     .product {\n//       animation-name: product-fade-out;\n//       animation-duration: 0.25s;\n//       animation-iteration-count: 1;\n//       animation-timing-function: ease-out;\n//     }\n//   }\n// }\n\n.navigation-menu {\n  background-color: var(--color-base-canvas);\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  // width: 13rem;\n  // margin-right: 1.5rem;\n  // position: absolute; top: 0;\n  // float: left;\n  white-space: nowrap;\n  // overflow-y: hidden;\n\n  .navigation-group {\n    flex-shrink: 1;\n  }\n  .navigation-logo {\n    display: table;\n    flex-grow: 1;\n  }\n  .navigation-link-qci {\n    display: table-cell;\n  }\n\n\n  .logo.qci {\n    // display: none;\n    position: unset;\n    width: 6rem;\n    margin: 2rem 0 1.5rem 0;\n  }\n\n  .search-tile {\n    border-top: 3px solid var(--color-base-border);\n\n    .icon {\n      fill: var(--color-elevated-draw);\n    }\n\n    .search-input {\n      margin: 1rem auto;\n      padding-right: 2rem;\n      width: 8.3rem;\n    }\n    .search-label-text {\n      display: none;\n    }\n    .search-clear-button {\n      background: none;\n      border: none;\n      margin-top: 0.9rem;\n      position: absolute; right: 0.35rem;\n      opacity: 0.7;\n      &:disabled {\n        display: none;\n      }\n      .icon.clear {\n        margin: 0;\n        top: 0;\n        right: 0.25rem;\n        height: 1.75rem;\n      }\n    }\n    .search-label:has(.search-input:focus) .search-help-button {\n      opacity: 1;\n    }\n    .search-help-button {\n      background: none;\n      border: none;\n      margin-top: 0.9rem;\n      position: absolute; right: 0.35rem;\n      opacity: 0.3;\n      &:disabled {\n        display: none;\n      }\n      .icon.info {\n        margin: 0;\n        top: 0;\n        right: 0.25rem;\n        height: 1.75rem;\n      }\n    }\n    .search-help-copy {\n      background-color: var(--color-elevated-canvas);\n      border: var(--border-width) solid var(--color-elevated-border);\n      color: var(--color-elevated-text);\n      display: none;\n      line-height: 1.5rem;\n      margin-top: -6.2rem;\n      padding: 1rem;\n      position: absolute; left: 13.5rem;\n      text-align: left;\n      white-space: pre-wrap;\n      width: 20rem;\n    }\n    &.help {\n      .search-label {\n        z-index: 1000;\n      }\n      .search-help-backdrop {\n        background-color: rgba(0, 0, 0, 0.1);\n        position: fixed; top: 0; right: 0; bottom: 0; left: 13rem;\n        animation-name: blur-in;\n        animation-duration: 0.1s;\n        animation-fill-mode: forwards;\n        z-index: 999;\n      }\n      .search-help-copy {\n        display: block;\n        z-index: 1000;\n        > p {\n          margin: 0;\n        }\n      }\n      .search-examples {\n        list-style-type: disc;\n        margin-left: 1.5rem;\n      }\n\n      .search-example-label {\n        color: var(--color-base-text);\n        display: block;\n        margin-top: 1.3rem;\n        margin-bottom: 0.3rem;\n      }\n      .search-example-example {\n        font-family: ui-monospace;\n        font-size: 1.2rem;\n      }\n    }\n  }\n\n  .button.navigation {\n    background: none;\n    border: none;\n    display: block;\n    font-size: 1rem;\n    padding: 0.5rem 1rem;\n    text-align: left;\n    width: 100%;\n    height: auto;\n\n    &.current {\n      background-color: var(--color-base-border);\n    }\n\n    &.sign-out {\n      border-bottom: none;\n      border-top: 1px solid var(--color-base-border);\n      color: var(--color-base-text);\n      display: block;\n      height: 3.2rem;\n      margin-bottom: 0 !important;\n      // position: absolute;\n      // bottom: 0;\n      margin-top: 2rem;\n      text-align: center;\n      // width: 13rem;\n\n      &.confirm {\n        color: var(--color-elevated-warn);\n      }\n    }\n  }\n\n  .button.navigation {\n    border-bottom: 1px solid var(--color-base-border);\n    font-size: 0.85rem;\n    padding: 0.2rem 1rem;\n\n    &:first-of-type:not(.documentation) {\n      border-top: 2px solid var(--color-base-border);\n      font-size: 1rem;\n      padding: 0.35rem 1rem;\n    }\n    &:last-child {\n      margin-bottom: 2rem;\n    }\n  }\n}\n\n.chrome .navigation-menu {\n  min-height: max(calc(100vh - 1px), 38rem);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
